import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSystemsIcon = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 24,
	viewBox: "0 0 20 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M4.32886 9.78751C4.69455 9.42181 4.9 8.92582 4.9 8.40865C4.9 7.89148 4.69455 7.39549 4.32886 7.02979C3.96316 6.66409 3.46717 6.45865 2.95 6.45865C2.43283 6.45865 1.93684 6.66409 1.57114 7.02979C1.20545 7.39549 1 7.89148 1 8.40865C1 8.92582 1.20545 9.42181 1.57114 9.78751C1.93684 10.1532 2.43283 10.3586 2.95 10.3586C3.46717 10.3586 3.96316 10.1532 4.32886 9.78751Z",
			stroke: "black",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.32886 17.7875C4.69455 17.4218 4.9 16.9258 4.9 16.4086C4.9 15.8915 4.69455 15.3955 4.32886 15.0298C3.96316 14.6641 3.46717 14.4586 2.95 14.4586C2.43283 14.4586 1.93684 14.6641 1.57114 15.0298C1.20545 15.3955 1 15.8915 1 16.4086C1 16.9258 1.20545 17.4218 1.57114 17.7875C1.93684 18.1532 2.43283 18.3586 2.95 18.3586C3.46717 18.3586 3.96316 18.1532 4.32886 17.7875Z",
			stroke: "black",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.3289 21.7875C11.6946 21.4218 11.9 20.9258 11.9 20.4086C11.9 19.8915 11.6946 19.3955 11.3289 19.0298C10.9632 18.6641 10.4672 18.4586 9.95 18.4586C9.43283 18.4586 8.93684 18.6641 8.57114 19.0298C8.20545 19.3955 8 19.8915 8 20.4086C8 20.9258 8.20545 21.4218 8.57114 21.7875C8.93684 22.1532 9.43283 22.3586 9.95 22.3586C10.4672 22.3586 10.9632 22.1532 11.3289 21.7875Z",
			stroke: "black",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.3289 17.7875C18.6946 17.4218 18.9 16.9258 18.9 16.4086C18.9 15.8915 18.6946 15.3955 18.3289 15.0298C17.9632 14.6641 17.4672 14.4586 16.95 14.4586C16.4328 14.4586 15.9368 14.6641 15.5711 15.0298C15.2054 15.3955 15 15.8915 15 16.4086C15 16.9258 15.2054 17.4218 15.5711 17.7875C15.9368 18.1532 16.4328 18.3586 16.95 18.3586C17.4672 18.3586 17.9632 18.1532 18.3289 17.7875Z",
			stroke: "black",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.3289 9.78751C18.6946 9.42181 18.9 8.92582 18.9 8.40865C18.9 7.89148 18.6946 7.39549 18.3289 7.02979C17.9632 6.66409 17.4672 6.45865 16.95 6.45865C16.4328 6.45865 15.9368 6.66409 15.5711 7.02979C15.2054 7.39549 15 7.89148 15 8.40865C15 8.92582 15.2054 9.42181 15.5711 9.78751C15.9368 10.1532 16.4328 10.3586 16.95 10.3586C17.4672 10.3586 17.9632 10.1532 18.3289 9.78751Z",
			stroke: "black",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.3289 4.78751C11.6946 4.42181 11.9 3.92582 11.9 3.40865C11.9 2.89148 11.6946 2.39549 11.3289 2.02979C10.9632 1.66409 10.4672 1.45865 9.95 1.45865C9.43283 1.45865 8.93684 1.66409 8.57114 2.02979C8.20545 2.39549 8 2.89148 8 3.40865C8 3.92582 8.20545 4.42181 8.57114 4.78751C8.93684 5.1532 9.43283 5.35865 9.95 5.35865C10.4672 5.35865 10.9632 5.1532 11.3289 4.78751Z",
			stroke: "black",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgSystemsIcon);
export default ForwardRef;
